import React from 'react';
import { useSelector } from 'react-redux';
import { Box } from '@tempmee/react';
import { useOfficeDiscountHistory } from '../../../../domain/Campaigns';
import { OfficePromoCodesTable } from './OfficePromoCodesTable';

/**
 * The office profile's Promotions → Discounts & Promo Codes tab (GOTU-6663).
 *
 * Office-only — it is registered on DNTTabs, not HYGTabs. The office id comes
 * from the profile's Redux `currentUser`; until that has resolved the query is
 * disabled and the card shows its loading state, since an empty list there
 * would claim the office has never been on a promotion.
 */
export const OfficePromoCodesTabScreen = () => {
  const officeId = useSelector((state) => state.users.currentUser?.id);
  const { history, isPending, isError } = useOfficeDiscountHistory(officeId);

  return (
    // width="100%": the profile's tab wrapper is a centring flex column, so
    // without it this Box shrinks to the table's intrinsic width. pt matches
    // the Best in Dental card's distance from the tab bar.
    <Box pt={4} width="100%">
      <OfficePromoCodesTable
        history={history}
        isPending={isPending || !officeId}
        isError={isError}
      />
    </Box>
  );
};

export default OfficePromoCodesTabScreen;
